import { Injectable } from '@angular/core';
import { io } from 'socket.io-client';
import { Observable } from 'rxjs';
import { SOCKET_IO_SERVICE } from '../api/api.service';
import { environment } from '../../../environments/environment';
import { CashDroEvents } from '../../enums/CashDroEvents';

@Injectable({
	providedIn: 'root',
})
export class SmoothrSocketService {
	private socket = io(environment.baseUrl, {
		path: `${SOCKET_IO_SERVICE}socket.io/`,
	});

	constructor() {}

	cashDroEvents(orderId: string): Observable<CashDroEvents> {
		this.socket.connect();
		return new Observable<any>(subscriber => {
			const handler = (id: string, event: CashDroEvents) => {
				if (id === orderId) {
					console.log('CashDroEvents', id, event);
					subscriber.next(event);
				}
			};

			this.socket.on('cashDro_status', handler);

			this.socket.emit('listen_cashdro', orderId, () => {
				console.log('CashDroEvents', 'listen_cashdro was called.');
			});

			// Teardown: runs when the subscriber unsubscribes
			return () => {
				this.socket.off('cashDro_status', handler);
			};
		});
	}

	async cancelPayment(orderId: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			this.socket.connect();
			this.socket.timeout(2_000).emit('cancel_cashDro', orderId, (err: any) => {
				console.log('cancel_cashDro was called.', err);
				if (err) {
					reject(err);
					return;
				}
				resolve();
			});
		});
	}
}
